// Mirrors propman's IsCashInstrumentID and hyperoptimal's
// is_cash_instrument_id: currency codes are exactly 3 uppercase ASCII
// letters, while ISINs are 12 characters and CUSIPs 9.
export function isCashInstrumentId(instrumentId: string): boolean {
  return /^[A-Z]{3}$/.test(instrumentId)
}
